import { useEffect, useState } from 'react';
import type { DirectorLanguage } from '@clutch/core';
import { useClient } from '../client';
import { asDirectorLanguage, htmlLang, languageLabel, offeredLanguages, type UiLanguage } from './i18n';
import { strings } from './strings';

let offered: Promise<UiLanguage[]> | undefined;

/** Languages the server can narrate (`GET /director/capabilities`), fetched once per page load. */
export function useLanguages(): UiLanguage[] {
  const client = useClient();
  const [langs, setLangs] = useState<UiLanguage[]>(['en']);
  useEffect(() => {
    const api = client.director;
    if (!api) return;
    let alive = true;
    offered ??= api.capabilities().then((c) => offeredLanguages(c)).catch(() => offeredLanguages(undefined));
    void offered.then((l) => alive && setLangs(l));
    return () => {
      alive = false;
    };
  }, [client]);
  return langs;
}

/** EN / हिन्दी (/ 中文 once the server lists it) segmented toggle. */
export function LangToggle({ value, onChange }: { value: DirectorLanguage; onChange: (l: DirectorLanguage) => void }) {
  const langs = useLanguages();
  const shown = langs.includes(value as UiLanguage) ? langs : [...langs, value as UiLanguage];
  return (
    <div className={`lang${shown.length > 2 ? ' lang--3' : ''}`} role="radiogroup" aria-label={strings(value).language} data-testid="lang-toggle">
      {shown.map((l) => (
        <button key={l} role="radio" aria-checked={value === l} className={value === l ? 'is-on' : ''} onClick={() => onChange(asDirectorLanguage(l))} data-testid={`lang-${l}`} {...(l !== 'en' ? { lang: htmlLang(l) } : {})}>
          {languageLabel(l)}
        </button>
      ))}
    </div>
  );
}
